<template>
<div class="section container mx-auto py-20">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-7 md:gap-10 lg:grid-cols-3 xl:grid-cols-4">
        <Item class="w-10/12 mx-auto"
            v-for="item in list"
            :key="item.id"
            :item="item"
        />
    </div>

</div>

</template>

<script>
import Item from './Item' 

export default ({
    components: {Item},
    data(){
        return{
            list: ""
        }
    },
    methods:{
        async getLibraries(){
            var get = `${process.env.VUE_APP_URL_CULTURAPP}api/libraries`;
            const response = await fetch(get,{method: 'GET'})
            this.list = await response.json()
        },
    },
    created(){
        this.getLibraries()
    }
        
})
</script>
